/*** SCROLL CONTROL ****/
// Hide Header on on scroll down
let didScroll;
let lastScrollTop = 0;
const delta = 5;
const navbarHeight = document.querySelector('header').offsetHeight;

window.addEventListener('scroll', function (event) {
  didScroll = true;
      if(document.querySelector('.page__product')!=null){
        let btn = document.querySelector('product-form');
        if(isElementVisible(btn, 0)){
           document.querySelector('fast-add') .classList.remove('fast-add--visible');
        }else{
            document.querySelector('fast-add') .classList.add('fast-add--visible'); 
        }
    }
});

window.addEventListener('load', function (event) {
  if (window.scrollY < navbarHeight) {
    document.querySelector('body').classList.add('scroll--top');
  } else {
    document.querySelector('body').classList.remove('scroll--top');
  }
if (window.location.pathname != '/') {
    var navbarHeightr = document.querySelector('header').offsetHeight;
      document.querySelector('main').style.marginTop = `${navbarHeight - 1}px`;
      if(document.querySelector('.collection__header') != null){
       document.querySelector('.collection__header').style.top = `${navbarHeight - 1}px`;
      }
      if(document.querySelector('.collection__main__nav') != null){
        document.querySelector('.collection__main__nav').closest('section').style.top = `${navbarHeightr - 1}px`;
      }
      if(document.querySelector('.page__product')!=null){
        let btn = document.querySelector('product-form');
        if(isElementVisible(btn, 0)){
           document.querySelector('fast-add') .classList.remove('fast-add--visible');
        }else{
            document.querySelector('fast-add') .classList.add('fast-add--visible'); 
        }
      }

    }
});

window.addEventListener('resize', function (event) {
    if (window.location.pathname != '/') {
      var navbarHeightr = document.querySelector('header').offsetHeight;
      document.querySelector('main').style.marginTop = `${navbarHeightr - 1}px`;
      if(document.querySelector('.collection__header') != null){
      document.querySelector('.collection__header').style.top = `${navbarHeightr - 1}px`;
      }
      if(document.querySelector('.collection__main__nav') != null){
        document.querySelector('.collection__main__nav').closest('section').style.top = `${navbarHeightr - 1}px`;
      }
    }
});


setInterval(function () {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 125);

function hasScrolled() {
  const st = window.scrollY;

  // Make sure they scroll more than delta
  if (Math.abs(lastScrollTop - st) <= delta) return;
  if (window.scrollY < navbarHeight) {
    document.querySelector('body').classList.add('page--top');
  } else {
    document.querySelector('body').classList.remove('page--top');
  }
  if (window.scrollY < 1) {
    document.querySelector('body').classList.add('scroll--top');
    document.querySelector('body').classList.remove('scroll--up');
    document.querySelector('body').classList.remove('scroll--down');
    if (document.querySelector('.collection__header') != null) {
      //document.querySelector('.collection__htrueeader').style.top = '0px';
    }
    lastScrollTop = st;
    return;
  } else {
    document.querySelector('body').classList.remove('scroll--top');
    document.querySelector('body').classList.remove('scroll--up');
  }

  if (st > lastScrollTop) {
    // Scroll Down
    document.querySelector('body').classList.remove('scroll--up');
    document.querySelector('body').classList.add('scroll--down');
    if (document.querySelector('.collection__header') != null) {
      //document.querySelector('.collection__header').style.top = '0px';
    }
  } else {
    // Scroll Up
    if (st + window.innerHeight < document.body.scrollHeight) {
      document.querySelector('body').classList.remove('scroll--down');
      document.querySelector('body').classList.add('scroll--up');
    }
    if (window.location.pathname != '/') {
      document.querySelector('main').style.marginTop = `${navbarHeight - 1}px`;
    }
    if (document.querySelector('.collection__header') != null) {
      //document.querySelector('.collection__header').style.top = navbarHeight + 'px';
    }
  }

  lastScrollTop = st;
}
//***************Guide popup */
window.addEventListener('load', function () {
    
  if (document.querySelector('.option__title__guide') != null) {
    document.querySelector('.option__title__guide').addEventListener('click', function () {
      document.querySelector('.popup__guide').classList.add('view');
    });
    document.querySelector('.guide__close').addEventListener('click', function () {
      document.querySelector('.popup__guide').classList.remove('view');
    });
  }
  document.querySelector('.open--menu-js').addEventListener('click', function () {
    document.querySelector('.footer__modal__container').classList.add('active');
  });
  document.querySelector('.footer__modal__overlay').addEventListener('click', function () {
    document.querySelector('.footer__modal__container').classList.remove('active');
  });
  document.querySelector('.footer__modal__close').addEventListener('click', function () {
    document.querySelector('.footer__modal__container').classList.remove('active');
  });
});

function isElementVisible(el, dist) {
	var rect     = el.getBoundingClientRect(),
	vWidth   = window.innerWidth || doc.documentElement.clientWidth,
	vHeight  = window.innerHeight || doc.documentElement.clientHeight,
	topHe=(rect.height > vHeight)?rect.height:vHeight;
    if(window.getComputedStyle(el).display === 'none'){
        return false;
    }
	// Return false if it's not in the viewport
	if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight-dist) {
       
		return false;
	}
	// Return true if any of its four corners are visible
	return true;
}
